var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remote-select"
  }, [_c('el-select', {
    attrs: {
      "multiple": _vm.multiple,
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item[_vm.optionValue],
      attrs: {
        "label": item[_vm.optionLabel],
        "value": item[_vm.optionValue]
      }
    })
  }), 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37b6c4b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/remoteSelect.vue
// module id = null
// module chunks = 